import $ from 'jquery';

import { Globals } from './Utils';

export default class FooterController {
    constructor() {
        this.FOOTER_COLS_SELECTOR = 'footer.sos-footer .inner.col-sm-6';
        this.assignColumns();
    }

    assignColumns() {
        if (!Globals.IsMobile) {
            let cols = $(this.FOOTER_COLS_SELECTOR).length;
            cols = Math.floor(12 / cols);
            $(this.FOOTER_COLS_SELECTOR).addClass(`col-lg-${cols}`);
        }
    }

    static init() {
        $(document).ready(() => {
            new FooterController(); // eslint-disable-line no-new
        });
    }
}
